<div class="w-100 float-left">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0">{{'passwordPolicy'|translate}}</h5>

    </div>
</div>
<div class="w-100 float-left" *ngIf="passwordPolicyData">
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
        <div class="form-group">
            <label>{{'minPasswordLength'|translate}}</label>
            <input type="number" name="displayPref" class="w-100" [(ngModel)]="passwordPolicyData.minLength">
        </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
        <div class="form-group">
            <label>{{'maxPasswordLength'|translate}}</label>
            <input type="number" name="displayPref" class="w-100" [(ngModel)]="passwordPolicyData.maxLength">
        </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
        <div class="form-group">
            <label>{{'minNumberLength'|translate}}</label>
            <input type="number" name="displayPref" class="w-100" [(ngModel)]="passwordPolicyData.minNumbers">
        </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
        <div class="form-group">
            <label>{{'minCapsLength'|translate}}</label>
            <input type="number" name="displayPref" class="w-100" [(ngModel)]="passwordPolicyData.minCaps">
        </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
        <div class="form-group">
            <label>{{'minLowerLength'|translate}}</label>
            <input type="number" name="displayPref" class="w-100" [(ngModel)]="passwordPolicyData.minLowers">
        </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
        <div class="form-group">
            <label>{{'minSpecialLength'|translate}}</label>
            <input type="number" name="displayPref" class="w-100" [(ngModel)]="passwordPolicyData.minSpecial">
        </div>
    </div>
</div>
<div class="w-100 float-left mt-4">
    <!-- <button class="btn btn-primary float-right" (click)="cancel()" > {{'cancel'|translate}} </button> -->
    <button class="btn btn-primary float-right mr-4" (click)="validatepasswordPolicy()"> {{'Save'|translate}}</button>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/passwordPolicy/passwordPolicy.html